import { useFormContext, useWatch } from 'react-hook-form'
import { InputMaskForm } from '../../../../components/Form/InputMaskForm'
import { Box, Spinner } from '@chakra-ui/react'
import { Button } from '../../../../components/Button'
import { api } from '../../../../services/api'
import { useQuery } from 'react-query'

async function searchCep(cep) {
  const response = await api.get(`/site/v2/pedido/busca-endereco-cliente/${cep}`)

  return response.data[0]
}

export function InputSearchCep() {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext()

  const cep = useWatch({ name: 'cep' })

  const {
    data: endereco,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['endereco', cep],
    queryFn: () => searchCep(cep),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10,
    enabled: false,
    onSuccess: (data) => {
      setValue('street', data.rua)
      setValue('neighborhood', data.bairro)
      setValue('city', data.cidade)
      setValue('state', data.uf)
      setValue('editar_endereco', false)
    },
  })

  const onChangeCep = async () => {
    refetch()
  }

  return (
    <Box position="relative" display="flex" alignItems="end" gap={2}>
      <InputMaskForm name="cep" mask="99999-999" maskChar="" width="100%" label="CEP" control={control} error={errors?.cep} />
      <Spinner size="sm" position="absolute" right="10px" top="50%" transform="translateY(-50%)" display={isLoading ? 'block' : 'none'} />

      <Button size="sm" onClick={onChangeCep}>
        Buscar
      </Button>
    </Box>
  )
}
